import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  SITE_LISTING,
  SITE_FILTERS,
  CHANGE_LOCATION,
  TASK_LISTING,
  SITE_REPOSITORY,
  CREATE_SITE_REPOSITORY,
  TAG_INFO,
  SITE_LISTING_FOR_ASSET,
  SITE_GATES_FOR_ASSET,
  PARENT_MATERIALS,
  ASSETS,
  SAVE_ASSETS,
  ASSET_INFO_DETAILS,
  CONTRACT_GATES_FOR_ASSET,
  PARENT_MATERIALS_CONTRACT,
  CLIENT_CONTRACT_MAPPING,
  TAG_VEHICLE,
  TAG_AUDIT,
  SITE_LISTING_MAINTENANCE,
  PR_LISTING,
  SITE_PR_LISTING,
  SERVICES_QTY,
  ACCEPT,
  REJECT,
  SERVICES_QTY_CONFIRMATON,
  PR_CONFIRMATION_DETAILS,
  DISMANTLE_SITE, DISMANTLE_MRF, CONTRACT_DATE, DISMANTLE_MRF_BY_SITE_ID,POS_REPLACE_RETURN,
  INSTALLATION_DATE_CHANGE_LIST,
  INSTALLATION_DATE_CHANGE_CREATE,
  INSTALLATION_DATE_CHANGE_APPROVAL,
  INSTALLATION_DATE_CHANGE_DETAIL,
  TAG_INFO_BY_VEHICLE_NO,
  APPROVE_PR,
  UPDATE_PR,
  GET_JMS_DETAILS,
  SUBMIT_JMS_DATA
} from './type';
import {CREATE_PROJECT} from "../../Valet/Project/type";

export const getSiteListing = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.installation.siteListing}?page=${page}`: `${Config.installation.siteListing}?site_no=${filterData.site_no ?? ''}&client_name=${filterData.client_name ?? ''}&site_type=${filterData.site_type ?? ''}&assignee_ids=${filterData.reportingTo ?? ''}&area_id=${filterData.area_id ?? ''}&status_id=${filterData.status_id ?? ''}&city_id=${filterData.city_id ?? ''}&commercial_type_id=${filterData.commercial_type_id ?? ''}&from_date=${filterData.from_date ?? ''}&to_date=${filterData.to_date ?? ''}&live_from_date=${filterData.live_from_date ?? ''}&live_to_date=${filterData.live_to_date ?? ''}&expiry_from_date=${filterData.expiry_from_date ?? ''}&expiry_to_date=${filterData.expiry_to_date ?? ''}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

export const getSiteListingForAssetMapping = (filterData = null, page = 1,latitude = null, longitude = null,) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.installation.siteListingForAsset}?page=${page}&latitude=${latitude}&longitude=${longitude}`: `${Config.installation.siteListingForAsset}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_ids=${filterData.reportee}&area_id=${filterData.area_id}&status_id=${filterData.status_id}&city_id=${filterData.city_id}&commercial_type_id=${filterData.commercial_type_id}&from_date=${filterData.from_date}&to_date=${filterData.to_date}&page=${page}&latitude=${latitude}&longitude=${longitude}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_LISTING_FOR_ASSET, payload: data.response.data });
    return data.response.data;
  }
};

export const getgatesByleadId = (leadId) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getgatesByleadId}?lead_id=${leadId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_GATES_FOR_ASSET, payload: data.response.data });
    return data.response.data;
  }
};

export const getClientAddressForContractMapping = (commId) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getClientAddressForContractMapping}?comm_id=${commId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CLIENT_CONTRACT_MAPPING, payload: data.response.data });
    return data.response.data;
  }
};

export const getgatesByContratctId = (site_id) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getgatesByContratctId}?site_id=${site_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CONTRACT_GATES_FOR_ASSET, payload: data.response.data });
    return data.response.data;
  }
};

export const getParentMaterials = () => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getParentMaterials}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: PARENT_MATERIALS, payload: data.response.data });
    return data.response.data;
  }
};

export const getParentMaterialsBySiteId = (siteId) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getParentMaterialsBySiteId}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: PARENT_MATERIALS_CONTRACT, payload: data.response.data });
    return data.response.data;
  }
};

export const getAssetsInfoData = (gateId,id) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getAssetsInfoData}?gate_id=${gateId}&asset_mapping_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: ASSET_INFO_DETAILS, payload: data.response.data });
    return data.response.data;
  }
};

export const getAssetsAndMakeData = (matId) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getAssetsAndMakeData}?mat_id=${matId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: ASSETS, payload: data.response.data });
    return data.response.data;
  }
};

export const saveSitesAssetsGateWise = (data) => async (
  dispatch 
) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveSitesAssetsGateWise}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_ASSETS, payload: data.response.data });
    return data.response.data;
  }
};

export const getSiteListingForEngg = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.installation.siteListForEngineer}?page=${page}`: `${Config.installation.siteListForEngineer}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_ids=${filterData.reportee}&area_id=${filterData.area_id}&status_id=${filterData.status_id}&city_id=${filterData.city_id}&commercial_type_id=${filterData.commercial_type_id}&from_date=${filterData.from_date}&to_date=${filterData.to_date}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

export const tagSearch = (tagId) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.tagInfo.tagSearch}?tag_id=${tagId}`
    );
  if (res) {
    const { data } = res;
    dispatch({ type: TAG_INFO, payload: data });
    return data;
  }
};

export const vehicleDetails = (tagId) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.tagInfo.vehicleDetails}?tag_id=${tagId}`
    );
  if (res) {
    const { data } = res;
    dispatch({ type: TAG_VEHICLE, payload: data });
    return data;
  }
};

// auditLogs

export const auditLogs = (data,tagId,page=1) => async (
 
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.tagInfo.auditLogs}&page=${page}`
    );
  if (res) {
    const { data } = res;
    dispatch({ type: TAG_AUDIT, payload: data.response.data });
    return data;
  }
};


export const getTaskListing = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.installation.taskListing}?page=${page}`
      : `${Config.installation.taskListing}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_ids=${filterData.reportee}&area_id=${filterData.area_id}&status_id=${filterData.status_id}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: TASK_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

export const siteLocationApproval = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.siteLocationApproval}`
  );
  if (res) {
    const { data } = res;
    return data.response.status;
  }
};

export const getSiteFilters = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.installation.siteFilters
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_FILTERS, payload: data.response.data });
    return data.response.data;
  }
};

export const getLocationChange = (id, isLocation) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.locationChange}?site_id=${id}&is_location_validate=${isLocation}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CHANGE_LOCATION, payload: data.response.data });
    return data.response.data;
  }
};

export const siteRepository = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.installation.siteRepository}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: CREATE_SITE_REPOSITORY,
      payload: data,
    });
    return true;
  }
};

export const getSiteRepository = (siteId, page = 1, flag = false) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.getSiteRepository}?site_id=${siteId}&page=${page}&flag=${flag}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_REPOSITORY, payload: data.response.data });
    return data.response.data;
  }
};

export const getSiteRepositoryFianance = (commId, page = 1) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.getSiteRepositoryFinance}?comm_id=${commId}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_REPOSITORY, payload: data.response.data });
    return data.response.data;
  }
};

export const acceptApproval = (requestData) => async (dispatch) => {
  dispatch({ type: ACCEPT, payload: null });
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.approvals.rejectOrApprovePr
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: "", payload: data.response.data });
    return true;
  }
};

export const rejectApproval = (requestData) => async (dispatch) => {
  dispatch({ type: REJECT, payload: null });
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.approvals.rejectOrApprovePr
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: "", payload: data.response.data });
    return true;
  }
};

export const getPrListing = (filterData = null, page = 1, status = null) => async (
  dispatch
) => {
  dispatch({ type: SERVICES_QTY,payload: null});
  dispatch({type: PR_LISTING, payload: null});
  const trimPrFilter = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return String(value).trim().replace(/^["']+|["']+$/g, '');
  };
  let url = `${Config.maintenance.fetchPrList}?page=${page}`;
  if (status !== null && status !== undefined && status !== '') {
    url += `&status=${encodeURIComponent(status)}`;
  }
  if (filterData) {
    const siteNo = trimPrFilter(filterData.site_no);
    const prId = trimPrFilter(filterData.pr_id);
    if (siteNo) url += `&site_no=${encodeURIComponent(siteNo)}`;
    if (prId) url += `&id=${encodeURIComponent(prId)}`;
  }
  const res = await callWebService(callTypes.get, '', url);
  if (res) {
    const { data } = res;
    dispatch({
      type: PR_LISTING,
      payload: data.response.data,
    });
    return true;
  }
};

export const getPrListingWithPo = (filterData = null, page = 1) => async (
  dispatch
) => {
  dispatch({ type: SERVICES_QTY,payload: null});
  dispatch({type: PR_LISTING, payload: null});
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null? `${Config.maintenance.fetchPrListPoGenerated}?page=${page}`: `${Config.maintenance.fetchPrListPoGenerated}?site_no=${filterData.site_no}&firm_name=${filterData.firm_name}&page=${page}&status=${filterData.status}&id=${filterData.id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PR_LISTING,
      payload: data.response.data,
    });
    return true;
  }
};

export const getSitePrListing = ({ siteId, siteNo } = {}, page = 1) => async (
  dispatch
) => {
  dispatch({ type: SITE_PR_LISTING, payload: null });

  const params = new URLSearchParams();
  params.set('page', String(page));
  if (siteId) params.set('site_id', String(siteId));
  if (siteNo) params.set('site_no', String(siteNo));

  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchPrListPoGenerated}?${params.toString()}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_PR_LISTING,
      payload: data.response.data,
    });
    return true;
  }
};

export const getServiceRequestedQty = (prNo = null) => async (
  dispatch
) => {
  dispatch({ type: SERVICES_QTY,payload: null});
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchServicesAgainstPr}?pr_no=${prNo}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SERVICES_QTY,
      payload: data.response.data,
    });
    return true;
  }
};

export const getPrConfirmationDetails = (prNo = null) => async (
  dispatch
) => {
  dispatch({ type: PR_CONFIRMATION_DETAILS,payload: null});
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getPrConfirmationDetails}?pr_no=${prNo}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PR_CONFIRMATION_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};

export const getServiceQuantityConfirmation = (prNo,vendorId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getServiceQuantityConfirmation}?pr_no=${prNo}&vendor_id=${vendorId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SERVICES_QTY_CONFIRMATON,
      payload: data.response.data,
    });
    return true;
  }
};

export const getSiteListingMaintenance = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null? `${Config.maintenance.fetchMaintenanceSites}?page=${page}`: `${Config.maintenance.fetchMaintenanceSites}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&commercial_type_id=${filterData.commercial_type_id}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_LISTING_MAINTENANCE,
      payload: data.response.data,
    });
    return true;
  }
};

export const saveServiceQuanity = (request) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    request,
    `${Config.maintenance.saveServiceQuanity}`
  );
  if (res) {
    const { data } = res;
    return data.response.status;
  }
};

export const getDismantleSite = (id) => async (
    dispatch
) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.dismantleSite}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DISMANTLE_SITE, payload: data.response.data });
    return data.response.data;
  }
};

export const getPublicSiteListingForChanges = (filterData = null, page = 1) => async (
  dispatch
) => {
const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.installation.sitePosReplaceAndReturn}?page=${page}`: `${Config.installation.sitePosReplaceAndReturn}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_ids=${filterData.reportee}&area_id=${filterData.area_id}&status_id=${filterData.status_id}&city_id=${filterData.city_id}&commercial_type_id=${filterData.commercial_type_id}&from_date=${filterData.from_date}&to_date=${filterData.to_date}&page=${page}`
);
if (res) {
  const { data } = res;
  dispatch({ type: POS_REPLACE_RETURN, payload: data.response.data });
  return data.response.data;
}
};

export const getDismantleMrf = (data) => async (
    dispatch
) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.installation.dismantleMrf}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DISMANTLE_MRF, payload: data.response });
    return data.response;
  }
};

export const contractDate = (id) => async (
    dispatch
) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.contractDate}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CONTRACT_DATE, payload: data.response.data });
    return data.response;
  }
};

export const getDismantleMrfBySiteId = (id) => async (
    dispatch
) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.dismantleMrfBySiteId}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DISMANTLE_MRF_BY_SITE_ID, payload: data.response.data });
    return data.response;
  }
};
export const getInstallationDateChangeListing = (page=1,comm_id=null,filterData=null) => async (dispatch) => {
  let url;
  if(comm_id!==null && comm_id!==undefined){
    url = `${Config.installation.getInstallationDateChangeListing}/`+`${comm_id}`+`?page=${page}`;
  }else{
    url = `${Config.installation.getInstallationDateChangeListing}`+`?page=${page}`;
  }
  
  const res = await callWebService(
      callTypes.get,
      '',
      filterData === null? url: url+`&site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_created_by=${filterData.site_created_by}&initial_date=${filterData.initial_date}&old_date=${filterData.old_date}&changed_date=${filterData.changed_date}&created_by=${filterData.created_by}&created_at=${filterData.created_at}&approved_by=${filterData.approved_by}&approved_on=${filterData.approved_on}&status=${filterData.status}`
    );
  if (res) {
    const {data} = res;
    dispatch({type: INSTALLATION_DATE_CHANGE_LIST, payload: data.response.data});
    return data.response.data;
  }
};

export const viewInstallationDateChangeDetail = (page=1,id) => async (dispatch) => {
  console.log(id);
  let url = `${Config.installation.viewInstallationDateChangeDetail}/`+`${id}`+`&page=${page}`;
  
  const res = await callWebService(
      callTypes.get,
      '',
      url
  );
  if (res) {
    const {data} = res;
    dispatch({type: INSTALLATION_DATE_CHANGE_DETAIL, payload: data.response.data});
    return data.response.data;
  }
};

export const createInstallationDateChange = (comm_id,requestData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.installation.createInstallationDateChange + `/${comm_id}`
  );
  if (res) {
    const {data} = res;
    dispatch({
      type: INSTALLATION_DATE_CHANGE_CREATE,
      payload: requestData,
    });
    return data.response.status;
  } else {
    return false;
  }
};

export const approveInstallationDateChange = (requestData) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.patch,
    requestData,
    Config.installation.approveInstallationDateChange
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};

export const tagSearchByVehicleNo = (vehicleNo) => async (
  dispatch
) => {
  dispatch({ type: TAG_INFO_BY_VEHICLE_NO, payload: null });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.tagInfo.tagSearchByVehicleNo}?vehicle_no=${vehicleNo}`
    );
  if (res) {
    const { data } = res;
    dispatch({ type: TAG_INFO_BY_VEHICLE_NO, payload: data });
    return data;
  }
};

export const UploadFlat = (info) => async (dispatch) => {
  const res = await callWebService(callTypes.post, info, Config.uploadFlat);
  if (res) {
    const {data} = res;
    if (data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const approvePRRequest = (data) => async (dispatch) => {

  try {

    const res = await callWebService(
      callTypes.post,
      data,
      Config.installation.approvePRRequest
    );

      if (res?.data) {
        dispatch({
          type: APPROVE_PR,
          payload: res.data.response || {},
        });
      }

    return res || { status_code: 400, message: "Something went wrong" };
    } catch (error) {
      console.error("Error in approving PR:", error);
      return { status_code: 400, message: error.message || "Something went wrong" };
    }

};

export const updatePR = (data) => async (dispatch) => {

  try {

    const res = await callWebService(
      callTypes.post,
      data,
      Config.installation.updatePRItems
    );

      if (res?.data) {
        dispatch({
          type: UPDATE_PR,
          payload: res.data.response || {},
        });
      }

    return res || { status_code: 400, message: "Something went wrong" };
    } catch (error) {
      console.error("Error in updating PR:", error);
      return { status_code: 400, message: error.message || "Something went wrong" };
    }

};
